<template>
	<b-modal ref="mdlChart" id="mdl-view-data" size="xl" :title="title" scrollable centered body-class="sa-modal-chart" ok-only ok-title="Chiudi" @shown="onShown">
		<v-chart ref="cmpGraphics" :not-merge="true" :option="chartOption" autoresize class="sa-widget-chart" />
	</b-modal>
</template>

<script>
import DataAnalysisChartMixinKekkoStrunz from "../mixins/DataAnalysisChartMixinKekkoStrunz";
import ECharts from "vue-echarts";
import { use } from "echarts/core";

// 2. Importa i moduli di ECharts (necessario per non caricare tutto il pacchetto)
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent } from "echarts/components";
// 3. Registra i moduli
use([CanvasRenderer, BarChart, LineChart, PieChart, GridComponent, TooltipComponent, LegendComponent]);
export default {
	mixins: [DataAnalysisChartMixinKekkoStrunz],
	components: { "v-chart": ECharts },
	data() {
		return {
			chartParams: { title: "", headerElements: [], bodyElement: { marginLeft: 300, legendVisible: true, horizontalDirection: false }, chartData: null },
		};
	},
	mounted() {
		//this.queryLoadData();
	},
	computed: {
		title() {
			return this.mxChartConfig ? this.mxChartConfig.title : "";
		},
	},
	methods: {
		show() {
			this.$refs.mdlChart.show();
		},
		setChartParams(chartParams) {
			console.log(chartParams);
			this.mxChartConfig = JSON.parse(JSON.stringify(chartParams));

			this.show();
		},
		onShown() {
			this.queryLoadData();
		},
	},
};
</script>

<style></style>
